import { createReducer, on } from '@ngrx/store';
import { EvaluationSurveyDto } from '@shared/dto';
import { logout } from '@auth/store/auth.actions';
import * as EvaluationSurveyActions from './evaluation-survey.actions';
import { State } from '@store/state.interface';

export const EVALUATION_SURVEY_FEATURE_KEY = 'evaluationSurvey';

export interface EvaluationSurveyState extends State<EvaluationSurveyDto> {}

export const initialState: EvaluationSurveyState = {
  data: [],
  detail: null,
  query: null,
  loading: false,
  error: null,
};

export const evaluationSurveyReducer = createReducer(
  initialState,
  // "loaded" is derived from the cached list (see selectEvaluationSurveyLoaded):
  // skip the fetch when we already hold data, unless an explicit refresh is asked.
  on(EvaluationSurveyActions.loadEvaluationSurvey, (state, { refresh }) =>
    refresh || !state.data?.length
      ? { ...state, loading: true, error: null }
      : state,
  ),
  on(EvaluationSurveyActions.loadEvaluationSurveySuccess, (state, { data }) => ({
    ...state,
    data,
    loading: false,
  })),
  on(EvaluationSurveyActions.loadEvaluationSurveyFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(logout, () => initialState),
);
